/** @module                         Hooks */

import { useTranslation }           from "react-i18next";

import { usePagename }              from "../../Hooks/usePagename";

import { useNavigate }              from "react-router-dom";

import useFetch                     from "../../Hooks/useFetch";

/** @module                         GQL */

import { LEGAL_DATA_LIST }          from "../../Queries/Contacts";

/** @module                         Components */

import Breadcrumbs                  from "../../Components/Dashboard/Breadcrumbs";

import Tabs                         from "../../Components/Dashboard/Global/Tabs";

import ComponentLoader              from "../../Components/Dashboard/Loaders/ComponentLoader";

const

/**
 *
 * @param { String } name
 *
 * @returns legal data list
 *
 */

LegalData = ( { name } ) => {

    usePagename ( name );

    const { t } = useTranslation ();

    const navigate = useNavigate ();

    const { loading, data } = useFetch ( LEGAL_DATA_LIST, {}, "network-only" );

    /** @returns */

    return (

        <section className="list">

            <Breadcrumbs />

            <Tabs data={ [

                { name: t ( "legal_data"        ), uri: "/app/contacts/legal-data" },

                { name: t ( "team"              ), uri: "/app/contacts/team" }

            ] } />

            { loading ?

                <ComponentLoader />:

                <div className="content">

                    <div className="actions">

                        <button

                            className="button add"

                            onClick={ () => navigate ( "/app/contacts/legal-data/add" ) }

                        >

                            { t ( "add_legal_data" ) }

                        </button>

                    </div>

                    <table className="table">

                        <thead>

                            <tr>

                                <th>{ t ( "legal_entity_name" ) }</th>

                                <th>{ t ( "registration_number" ) }</th>

                                <th>{ t ( "bank_accounts" ) }</th>

                                <th>{ t ( "country" ) }</th>

                                <th>{ t ( "type" ) }</th>

                                <th>{ t ( "actions" ) }</th>

                            </tr>

                        </thead>

                        <tbody>

                            { data?.adminLegalDataList?.map ( ( item ) => {

                                const defaultBank = item.bankAccounts?.find(acc => acc.isDefault);

                                const enabledCount = item.bankAccounts?.filter(acc => acc.isEnabled).length || 0;

                                return (

                                    <tr key={ item.id }>

                                        <td>{ item.legalEntityName }</td>

                                        <td>{ item.registrationNumber }</td>

                                        <td>

                                            { defaultBank ? (

                                                <div>

                                                    <div>{ defaultBank.bankName }</div>

                                                    <div style={{ fontSize: '0.85em', color: '#666' }}>{ defaultBank.iban }</div>

                                                    { enabledCount > 1 && (

                                                        <div style={{ fontSize: '0.85em', color: '#999' }}>

                                                            +{ enabledCount - 1 } { t ( "more" ) }

                                                        </div>

                                                    ) }

                                                </div>

                                            ) : item.bankName ? (

                                                <div>

                                                    <div>{ item.bankName }</div>

                                                    <div style={{ fontSize: '0.85em', color: '#666' }}>{ item.accountNumber }</div>

                                                </div>

                                            ) : (

                                                <span style={{ color: '#999' }}>{ t ( "no_bank_accounts" ) }</span>

                                            ) }

                                        </td>

                                        <td>{ item.countryCode || "-" }</td>

                                        <td>

                                            { !item.countryCode ?

                                                <span className="badge success">{ t ( "default" ) }</span> :

                                                <span className="badge">{ t ( "country_specific" ) }</span>

                                            }

                                        </td>

                                        <td>

                                            <button

                                                className="button edit"

                                                onClick={ () => navigate ( `/app/contacts/legal-data/edit/${ item.id }` ) }

                                            >

                                                { t ( "edit" ) }

                                            </button>

                                        </td>

                                    </tr>

                                );

                            } ) }

                        </tbody>

                    </table>

                </div>

            }

        </section>

    );

};

/** @exports LegalData */

export default LegalData;
